import * as React from "react";
import { cn } from "./cn";
import type { TypeListProps } from "./ListTypes";

/**
 * Tailwind CSS implementation of List. Renders the `as` element (ul/ol) with
 * the semantic `seeds-list` class from list.css — no runtime CSS-in-JS.
 *
 * The semantic class is placed before the consumer `className` so consumer
 * utilities can override the layered base styles.
 */
const ListTailwind = ({
  as: Element = "ul",
  children,
  className,
  ...rest
}: TypeListProps) => {
  return (
    <Element
      className={cn("seeds-list", className)}
      // On the Tailwind path system props are absent at runtime (they route to
      // the styled path), so the remaining rest is native attributes only.
      {...(rest as React.HTMLAttributes<HTMLUListElement | HTMLOListElement>)}
    >
      {children}
    </Element>
  );
};

ListTailwind.displayName = "List";

export default ListTailwind;
